import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["formatOption", "pdfUpload"]

    connect() {
        this.togglePdfUpload()
    }

    togglePdfUpload() {
        // ⛔ Une cible absente fait lever connect() et TOUT le contrôleur meurt :
        // c'est ainsi que la zone d'envoi de document ne s'ouvrait jamais.
        if (!this.hasPdfUploadTarget) return

        const coche = this.formatOptionTargets.find((radio) => radio.checked)
        const format = coche ? coche.value : null
        this.pdfUploadTarget.classList.toggle("hidden", format !== "pdf")
    }
}
